module.exports = __webpack_public_path__ + "img/foot-bgc.b79fe957.png";